import { render } from "./MoviesCard.vue?vue&type=template&id=7331e726&ts=true"
import script from "./MoviesCard.vue?vue&type=script&lang=ts"
export * from "./MoviesCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__